module.exports = __webpack_public_path__ + "img/title-bg.af0767e1.png";